import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsAlcadaClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/alcada');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Alcada');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/alcada', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Alcada');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/alcada', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Alcada');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/alcada/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Alcada');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/alcada/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Alcada');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/alcada/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Alcada');
    }
  }
}
